import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';

export const FETCH_BOOKING_CART = 'FETCH_BOOKING_CART';
const UPDATE_BOOKING_CART = 'UPDATE_BOOKING_CART';

export const initialState = {
  data: {},
  errorResponse: {},
  editingBookingId: '',
};

export const cartReducer = (state = initialState, action = {}) => {
  const cartBookings = state.data?.bookingsCart?.cartBookings;
  switch (action.type) {
    case FETCH_BOOKING_CART:
      return {
        ...state,
      };
    case resolve(FETCH_BOOKING_CART):
      return {
        ...state,
        data: get(action, 'payload', {}),
        errorResponse: {},
      };
    case reject(FETCH_BOOKING_CART):
      return {
        ...state,
        errorResponse: {
          errors: action.payload.errors,
        },
      };
    case UPDATE_BOOKING_CART:
      return {
        ...state,
        editingBookingId: action.payload.bookingId,
      };
    case resolve(UPDATE_BOOKING_CART):
      const bookingToUpdateIndex = cartBookings.findIndex(
        (booking) => booking.bookingId === state.editingBookingId,
      );
      const updatedCartBookings = [
        ...cartBookings.slice(0, bookingToUpdateIndex),
        { ...action.payload.addServiceCart?.cart, ...action.payload.removeServiceCart?.cart },
        ...cartBookings.slice(bookingToUpdateIndex + 1),
      ];
      return {
        ...state,
        data: {
          ...state.data,
          bookingsCart: {
            ...state.data.bookingsCart,
            amount: {
              total: {
                ...state.data.bookingsCart.amount.total,
                ...action.payload.addServiceCart?.totalAmount,
                ...action.payload.removeServiceCart?.totalAmount,
              },
            },
            isEmpty: updatedCartBookings.every((cart) => cart.isEmpty),
            cartBookings: updatedCartBookings,
          },
        },
      };
    case reject(UPDATE_BOOKING_CART):
      return {
        ...state,
        errorResponse: {
          errors: action.payload.errors,
        },
      };
    default:
      return state;
  }
};
